import { ActionType } from 'typesafe-actions';
import { select, put, delay, all, takeEvery } from 'redux-saga/effects';

import {
  KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS as HTTP_KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS,
  CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM as HTTP_CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM,
  KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS,
} from 'CorePackage/MainModule/constants/httpErrors';
import {
  KNM_NOT_AVAILABLE_LINK_TO_PLAN_LESS_30_DAYS,
  KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS as NOTICE_KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS,
  CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM as NOTICE_CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM,
  KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS as NOTICE_KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS,
  HANDLING_PLAN,
} from 'CorePackage/MainModule/constants/notices';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  fetchPlans,
  deletePlan,
  createPlan,
  updatePlanStatusById,
  updateErknmPlanStatusById,
  updatePlanStatusToConsiderById,
  exportPlans,
  exportDocumentsForKnoByPlanId,
  exportPlan,
  getPlanStatuses,
  fetchPlanById,
  getApprovedPlansForCurrentYear,
} from 'APIPackage/PlanListModule/services/knmPlanApi';
import { IKnmPlanResponse } from 'APIPackage/PlanListModule/interfaces/IKnmPlanResponse';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { initialPlanListFilter } from 'PlanListPackage/PlanListFiltersModule/constants/initialPlanListFilter';
import { mapPlanFilterToRaw } from 'PlanListPackage/PlanListPanelModule/common/mapPlanFilterToRaw';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { catalogGet } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { planListFilterGetMeta } from 'PlanListPackage/PlanListPanelModule/actions/planListFilterActions';
import {
  notifyExportSuccess,
  notifyExportError,
  notifyPlanStatusesUpdateSuccess,
  notifyPlanStatusesUpdateError,
} from 'CorePackage/MainModule/sagas/commonNotificationSagas';
import { CoreActionsEnum } from 'CorePackage/MainModule/enums/CoreActionsEnum';
import { ROUTE_TEMPLATES } from 'CorePackage/MainModule/routes/routes';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { PlanStatusEnum } from 'APIPackage/PlanListModule/enums/PlanStatusEnum';
import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';
import { planSignSaga } from 'PlanPackage/MainModule/sagas/planSignSaga';
import { IResponseError } from 'APIPackage/MainModule/interfaces/IResponseError';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { coreSetLoadingProgress } from 'CorePackage/MainModule/actions/coreActions';
import { linkKnmToPlan } from 'APIPackage/KnmModule/services/knmPlanApi';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import {
  planListSetData,
  planListGetData,
  planListRemovePlans,
  planListCreatePlan,
  planListUpdatePlanStatus,
  planListUpdateErknmPlanStatus,
  planListUpdatePlanStatusToConsider,
  planListExportPlans,
  planListExportDocsForKno,
  planListExportPlanById,
  planListLinkKnmToPlan,
  planListSetStatuses,
  planListGetStatuses,
  planListSetPlan,
  planListGetPlanById,
  planListSignPlanById,
  planListGetApprovedForCurrentYear,
  planListSetApprovedForCurrentYear,
  planListGetPlanSelectOptions,
} from '../actions/planListActions';
import { PlanListActionsEnum } from '../enums/PlanListActionsEnum';
import { mapRawToPlan } from '../common/mapRawToPlan';
import { IKnmPlanFilterRaw } from '../../../APIPackage/PlanListModule/interfaces/IKnmPlanFilterRaw';
import { emptyKnmPlanFilterRaw } from '../../PlanListPanelModule/common/emptyKnmPlanFilterRaw';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { dictionariesFederalLawsGet } from '../../../CorePackage/DictionariesModule/actions/dictionariesActions';

export function* watchPlanListSaga() {
  yield takeEvery(CoreActionsEnum.CORE_SET_LAW_INTERFACE, switchLawInterfaceSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_INIT_PAGE, initPageSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_GET_DATA, fetchPlanListSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_GET_DATA_NEXT_PAGE, fetchPlanListNextPageSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_REMOVE_PLANS, removePlansSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_UPDATE_PLAN_STATUS, updatePlanStatusSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_UPDATE_ERKNM_PLAN_STATUS, updateErknmPlanStatusSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_UPDATE_PLAN_STATUS_TO_CONSIDER, updatePlanStatusToConsiderSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_CREATE_PLAN, createPlanSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_SET_ORDER, changeOrderSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_EXPORT_PLANS, exportPlansSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_EXPORT_PLAN_BY_ID, exportPlanByIdSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_EXPORT_DOCS_FOR_KNO, exportDocsForKno);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_LINK_KNM_TO_PLAN, linkKnmToPlanSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_GET_STATUSES, fetchPlanStatusesSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_GET_PLAN_BY_ID, fetchPlanByIdSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_SIGN_PLAN_BY_ID, signPlanSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_GET_APPROVED_FOR_CURRENT_YEAR, getApprovedPlansForCurrentYearSaga);
  yield takeEvery(PlanListActionsEnum.PLAN_LIST_GET_PLAN_SELECT_OPTIONS, planListGetPlanSelectOptionsSaga);
}

const PLAN_LIST_REFRESH_DELAY = 1000;
const WARNING_KNMS_SIZE = 200;

const planListPageCatalogs: CommonCatalogsNamesEnum[] = [
  CommonCatalogsNamesEnum.USER_KNOS,
  CommonCatalogsNamesEnum.KNM_PLAN_TYPES,
];

function* switchLawInterfaceSaga() {
  if (window.location.pathname === ROUTE_TEMPLATES) {
    yield put(planListFilterGetMeta());
    yield put(planListGetStatuses());
  }
}

function* initPageSaga() {
  yield all(planListPageCatalogs.map(catalogName => put(catalogGet(catalogName))));
  yield put(dictionariesFederalLawsGet());
  yield put(planListFilterGetMeta());
  yield put(planListGetStatuses());
}

function* fetchPlanListSaga(action: ActionType<typeof planListGetData>) {
  function* funcTry() {
    const state: IRootState = yield select();
    const { searchValue } = action.payload;
    const { order } = state.planList;
    const { current } = state.planListFilter;
    const isFilterOn = getStorageItem<boolean>(StorageNamesEnum.PLAN_FILTER_ON);
    const rawFilter = mapPlanFilterToRaw((isFilterOn && current) || initialPlanListFilter);

    const res: IKnmPlanResponse = yield fetchPlans(
      searchValue ? { ...rawFilter, id: Number(searchValue) } : rawFilter,
      0,
      order ?? '',
    );

    const plans = res.list.map(mapRawToPlan);

    yield put(planListSetData(plans, res.page, res.pageCount, res.totalCount));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* fetchPlanListNextPageSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const { data, order, page } = state.planList;
    const { current } = state.planListFilter;
    const isFilterOn = getStorageItem<boolean>(StorageNamesEnum.PLAN_FILTER_ON);
    const filter = mapPlanFilterToRaw((isFilterOn && current) || initialPlanListFilter);
    const res: IKnmPlanResponse = yield fetchPlans(filter, page + 1, order ?? '');
    const plans = res.list.map(mapRawToPlan);

    yield put(planListSetData([...data, ...plans], res.page, res.pageCount, res.totalCount));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* removePlansSaga(action: ActionType<typeof planListRemovePlans>) {
  yield sagaWrapper({
    *funcTry() {
      const { ids } = action.payload;

      yield all(ids.map(id => deletePlan(id)));
      yield delay(PLAN_LIST_REFRESH_DELAY);
      yield put(planListGetData());
      yield put(
        addNoticeAction({
          noticeType: NoticeTypesEnum.SUCCESS,
          messageType: MessageTypesEnum.DELETE_SUCCESS,
          renderContent: ids.length > 1 ? 'Планы успешно удалены.' : 'План успешно удален.',
        }),
      );
    },
  });
}

function* createPlanSaga(action: ActionType<typeof planListCreatePlan>) {
  function* funcTry() {
    const { plan, getSuccessLink, onClose } = action.payload;
    const state: IRootState = yield select();
    const { lawInterface } = state.core;
    const { id } = yield createPlan(plan, lawInterface === LawInterfacesEnum.FZ_248);

    yield delay(PLAN_LIST_REFRESH_DELAY);
    yield put(planListGetData());
    onClose();

    yield put(
      addNoticeAction({
        noticeType: NoticeTypesEnum.SUCCESS,
        messageType: MessageTypesEnum.CREATE_PLAN_KNM,
        renderContent: getSuccessLink(id),
      }),
    );
  }

  yield sagaWrapper({
    funcTry,
    *funcCatch(res: IResponseError) {
      let renderContent = 'Ошибка создания плана КНМ';

      if (res?.message?.includes(HTTP_CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM)) {
        renderContent = NOTICE_CAN_NOT_CREATE_KNM_PLAN_KNO_ORGANIZATION_NOT_PRESENT_IN_ERKNM;
      }

      renderContent = res?.message || renderContent;

      yield put(
        addNoticeAction({
          noticeType: NoticeTypesEnum.ERROR,
          messageType: MessageTypesEnum.CREATE_PLAN_KNM,
          renderContent,
        }),
      );
    },
  });
}

function* updatePlanStatusSaga(action: ActionType<typeof planListUpdatePlanStatus>) {
  yield sagaWrapper({
    *funcTry() {
      const { id, status, searchValue } = action.payload;

      yield updatePlanStatusById(id, status);
      yield delay(PLAN_LIST_REFRESH_DELAY);
      yield put(planListGetData(searchValue));
      yield notifyPlanStatusesUpdateSuccess();
    },
    *funcCatch(res: IResponseError) {
      yield notifyPlanStatusesUpdateError(res.message || '');
    },
  });
}

function* updateErknmPlanStatusSaga(action: ActionType<typeof planListUpdateErknmPlanStatus>) {
  const { id, data, knmAmount, searchValue } = action.payload;

  yield sagaWrapper({
    *funcTry() {
      if (data.newStatus === ErknmPlanStatusesEnum.UNDER_CONSIDERATION && knmAmount > WARNING_KNMS_SIZE) {
        yield put(
          addNoticeAction({
            noticeType: NoticeTypesEnum.WARNING,
            messageType: MessageTypesEnum.PLAN_UPDATE_STATUS,
            renderContent: HANDLING_PLAN,
          }),
        );
      }
      yield updateErknmPlanStatusById(id, data);
      yield delay(PLAN_LIST_REFRESH_DELAY);
      if (searchValue) {
        yield put(planListGetData(searchValue));
      }
      yield notifyPlanStatusesUpdateSuccess();
    },
    *funcCatch(res: IResponseError) {
      yield notifyPlanStatusesUpdateError(res.message || '', data.newStatus);
    },
  });
}

function* updatePlanStatusToConsiderSaga(action: ActionType<typeof planListUpdatePlanStatusToConsider>) {
  yield sagaWrapper({
    *funcTry() {
      const { id, data, searchValue } = action.payload;

      yield updatePlanStatusToConsiderById(id, data);
      yield delay(PLAN_LIST_REFRESH_DELAY);
      if (searchValue) {
        yield put(planListGetData(searchValue));
      }
      yield notifyPlanStatusesUpdateSuccess();
    },
    *funcCatch(res: IResponseError) {
      yield notifyPlanStatusesUpdateError(res.message || '');
    },
  });
}

function* changeOrderSaga() {
  yield put(planListGetData());
}

function* exportPlansSaga(action: ActionType<typeof planListExportPlans>) {
  function* funcTry() {
    const { format } = action.payload;
    const state: IRootState = yield select();
    const { current } = state.planListFilter;
    const isFilterOn = getStorageItem<boolean>(StorageNamesEnum.PLAN_FILTER_ON);
    const filter = mapPlanFilterToRaw((isFilterOn && current) || initialPlanListFilter);
    const meta: IExport = yield exportPlans(format, filter);

    yield notifyExportSuccess(meta.id);
  }

  yield sagaWrapper({
    funcTry,
    *funcCatch() {
      yield notifyExportError();
    },
  });
}

function* exportPlanByIdSaga(action: ActionType<typeof planListExportPlanById>) {
  function* funcTry() {
    const { format, id, isApproved } = action.payload;
    const meta: IExport = yield exportPlan(format, id, isApproved, false);

    yield notifyExportSuccess(meta.id);
  }

  yield sagaWrapper({
    funcTry,
    *funcCatch() {
      yield notifyExportError();
    },
  });
}

function* exportDocsForKno(action: ActionType<typeof planListExportDocsForKno>) {
  function* funcTry() {
    const { planId } = action.payload;
    const meta: IExport = yield exportDocumentsForKnoByPlanId(planId);

    yield notifyExportSuccess(meta.id);
  }

  yield sagaWrapper({
    funcTry,
    *funcCatch() {
      yield notifyExportError();
    },
  });
}

function* linkKnmToPlanSaga(action: ActionType<typeof planListLinkKnmToPlan>) {
  yield sagaWrapper({
    *funcTry() {
      const { planId, knmId, reasonChangeType } = action.payload;

      yield linkKnmToPlan(planId, knmId, reasonChangeType);
      yield put(
        addNoticeAction({
          noticeType: NoticeTypesEnum.SUCCESS,
          messageType: MessageTypesEnum.ADD_KNM_TO_PLAN,
          renderContent: 'КНМ успешно добавлено к плану',
        }),
      );

      yield delay(PLAN_LIST_REFRESH_DELAY);
      yield put(planListGetData());
    },
    *funcCatch(res: IResponseError) {
      let renderContent = 'Ошибка добавления КНМ к плану';

      if (res?.message?.includes('KNM_NOT_AVAILABLE_LINK_TO_PLAN')) {
        renderContent = KNM_NOT_AVAILABLE_LINK_TO_PLAN_LESS_30_DAYS;
      }
      if (res?.message?.includes(KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS)) {
        renderContent = NOTICE_KNM_NOT_AVAILABLE_LINK_TO_PLAN_YEAR_OF_PLAN_AND_KNM_NOT_EQUALS;
      }
      if (res?.message?.includes(HTTP_KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS)) {
        renderContent = NOTICE_KNM_NOT_AVAILABLE_LINK_TO_PLAN_KNO_OR_PROSECUTOR_NOT_EQUALS;
      }
      if (res?.message?.includes('UNPLANNED_KNM_NOT_AVAILABLE_LINK_TO_PLAN')) {
        renderContent = 'Включение внеплановой проверки в план невозможно';
      }

      yield put(
        addNoticeAction({
          noticeType: NoticeTypesEnum.ERROR,
          messageType: MessageTypesEnum.ADD_KNM_TO_PLAN,
          renderContent,
        }),
      );
    },
  });
}

function* fetchPlanStatusesSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const { lawInterface } = state.core;
    const isErknm = lawInterface === LawInterfacesEnum.FZ_248;
    const res: Array<PlanStatusEnum | ErknmPlanStatusesEnum> = yield getPlanStatuses(isErknm);

    yield put(planListSetStatuses(res));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* fetchPlanByIdSaga(action: ActionType<typeof planListGetPlanById>) {
  function* funcTry() {
    const { id } = action.payload;
    const res: IKnmPlan = yield fetchPlanById(id);

    yield put(planListSetPlan(res));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* signPlanSaga(action: ActionType<typeof planListSignPlanById>) {
  const { planId, certificate, searchValue, errors } = action.payload;

  const unload = (e: BeforeUnloadEvent) => {
    e.returnValue = '';

    return '';
  };

  yield sagaWrapper({
    *funcTry() {
      if (planId) {
        yield put(coreSetLoadingProgress(0));
        window.addEventListener('beforeunload', unload);
        yield planSignSaga(planId, certificate, { page: 'planList', searchValue }, errors);
      }
    },
    *funcCatch() {
      yield put(
        addNoticeAction({
          noticeType: NoticeTypesEnum.ERROR,
          messageType: MessageTypesEnum.SIGN_PLAN,
          renderContent: 'Ошибка подписания плана',
        }),
      );
    },
    *funcFinally() {
      yield put(coreSetLoadingProgress(undefined));
      window.removeEventListener('beforeunload', unload);
    },
  });
}

function* getApprovedPlansForCurrentYearSaga(action: ActionType<typeof planListGetApprovedForCurrentYear>) {
  function* funcTry() {
    const { frguProsecutorOrgId, knoId, ervkProsecutorOrgId, kindKontrolId } = action.payload;
    const plans: number[] = yield getApprovedPlansForCurrentYear(
      frguProsecutorOrgId,
      ervkProsecutorOrgId,
      knoId,
      kindKontrolId,
    );

    yield put(planListSetApprovedForCurrentYear(plans));
  }

  function* funcCatch() {
    yield put(planListSetApprovedForCurrentYear([]));
  }

  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* planListGetPlanSelectOptionsSaga(action: ActionType<typeof planListGetPlanSelectOptions>) {
  function* funcTry() {
    const { planIdQuery, isErp, callback } = action.payload;
    const filter: IKnmPlanFilterRaw = {
      ...emptyKnmPlanFilterRaw,
      idStartedWith: planIdQuery,
    };
    const result: IKnmPlanResponse = yield fetchPlans(filter, 0, undefined, 10, isErp);
    const options: ISelectOption[] = result.list.map(item => ({
      id: item.id,
      label: item.id.toString(),
      value: item.id,
    }));

    callback(options);
  }

  yield sagaWrapper({ funcTry });
}
